<template>
<section class="title-page">
  <div class="title-main" :style="titleStyle">
    <div class="title-left" @click="$router.go(-1)"><i class="icon-icon_arrowleft-01 iconfont"></i><span>返回</span></div>
    <div class="title-middle">{{titleName}}</div>
    <div class="title-right"></div>
  </div>
</section>
</template>

<script>
export default {
  props: ['titleStyle', 'titleName'],
  data () {
    return {}
  }
}
</script>

<style lang="scss">
.title-page {
  height: 40px;
  .title-main {
    position: fixed;
    z-index: 100;
    height: 40px;
    line-height: 40px;
    display: flex;
    justify-content: space-between;
    width: 7.5rem;
    margin: 0 auto;
    padding: 0 12px;
    .title-left {
      flex: 0 0 80px;
      cursor: pointer;
      span {
        font-size: 14px;
      }
    }
    .title-right {
      flex: 0 0 80px;
    }
  }
}
</style>
